import { Box, Button } from "@mui/material";
import { useEffect, useState } from "react";
import Field from "../../interfaces/field";
import { useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../store/store";
import SearchResultGrid from "../searchResultGrid/searchResultGrid";
import fieldColumnDef from "../../colDef/fieldColumnDef";
import filterSectionStyle from "../../styles/filterSectionStyle";
import AddFieldModal from "../modals/addFieldModal";
import EditFieldModal from "../modals/editFieldModal";
import { GridRowSelectionModel } from "@mui/x-data-grid";
import { decodedJWT, getUserRole } from "../../utils/commonUtils";
import JWTTokenPayload from "../../interfaces/JWTTokenPayload";
import RoleManagement from "../../security/roleManagement";

const ManageField: React.FC = () => {
    const standardFields = useSelector((state: RootState) => state.fields.fields);
    const [searchResults, setSearchResults] = useState<Field[]>(standardFields);
    const [addModalOpen, setAddModalOpen] = useState<boolean>(false);
    const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
    const [selectedRows, setSelectedRows] = useState<Field[]>([]);
    const token: JWTTokenPayload | false = decodedJWT();
    const userRole = getUserRole(token);

    const handleOpenAddModal = () => setAddModalOpen(true);
    const handleOpenEditModal = () => setEditModalOpen(true);

    const handleSelectedRows = (ids: GridRowSelectionModel) => {
        setSelectedRows(standardFields.filter(field => Array.from(ids.ids).includes(field.field_id)));
    };

    useEffect(() => {
        setSearchResults(standardFields);
    }, [standardFields]);

    return (
        <Box m={2}>
            { // superadmin only sees standard fields which should not be ADD/EDIT from console
                !RoleManagement.isSuperAdmin(userRole) && (
                    <Box sx={filterSectionStyle}>
                        <Box display="flex" justifyContent="flex-end" mb={2}>
                            {selectedRows.length === 1 && !selectedRows[0].is_standard && (
                                <Button
                                    sx={{ mr: 1 }}
                                    variant="contained"
                                    onClick={handleOpenEditModal}
                                >
                                    Edit Field
                                </Button>
                            )}
                            <Button
                                variant="contained"
                                onClick={handleOpenAddModal}
                            >
                                Add Field
                            </Button>
                        </Box>
                    </Box>
                )
            }

            <SearchResultGrid
                height='72vh'
                getRowId={(row: Field) => row.field_id}
                results={searchResults}
                onSelectRow={handleSelectedRows}
                columns={fieldColumnDef}
            />

            <AddFieldModal
                modalVisible={addModalOpen}
                closeModal={() => setAddModalOpen(false)}
            />

            <EditFieldModal
                modalVisible={editModalOpen}
                closeModal={() => setEditModalOpen(false)}
                selectedRow={selectedRows.length > 0 ? selectedRows[0] : null}
            />
        </Box>
    );
}

export default ManageField;
